import { render, staticRenderFns } from "./MinisiteContact.vue?vue&type=template&id=be329b66&scoped=true&"
import script from "./MinisiteContact.vue?vue&type=script&lang=js&"
export * from "./MinisiteContact.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteContact.vue?vue&type=style&index=0&id=be329b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be329b66",
  null
  
)

export default component.exports